import Action from "./action";
import Prune from "./prune";
import {ActionTypeEnum} from "./training-literals";

export default class LoadTimeline extends Action {
    timelines;
    prune;

    /* If We need some action keep active from previous timeline that is also present
    this timeline then we can simply pass the type of the action in preserverActionList Array */
    constructor(props) {
        super(props);
        this.timelines = props.timelines || [];
        this.prune = new Prune(props.prune || {});
        this.preserveActionList = props.preserveActionList || [ActionTypeEnum.STEP_INSTRUCTION_MENU];
        // if any action need to be active after loading timeline
    }

    async execute(eventLoop) {

        let timelineIds = [];
        let timelineNames = [];
        let hasPreserveAction = false;
        let hasStepMenuFrame = false;

        for (let timeline of this.timelines) {
            const result = await Action.parseValue(timeline, eventLoop);
            if (!result) continue;

            const timelineToBeLoaded = eventLoop.training.timelines[result];
            timelineIds.push(result);
            timelineNames.push(timelineToBeLoaded.name);

            if (!hasPreserveAction) {
                hasPreserveAction = timelineToBeLoaded.actionSequence.some(
                    action => this.preserveActionList.includes(action.type) && action.properties.startTime === 0
                );
            }

            if (!hasStepMenuFrame && hasPreserveAction) {
                const loadStateAction = timelineToBeLoaded.actionSequence.find(
                    action => (action.type === ActionTypeEnum.LOAD_STATE) && action.startTime === 0
                );

                hasStepMenuFrame = eventLoop.training.states[loadStateAction?.states[0]]?.__actionStates?.stepMenuFrame;
                const stepMenuAction = eventLoop.runningActions.find(action => action.type === "StepInstructionMenu");
                if (hasStepMenuFrame && stepMenuAction) {
                    hasStepMenuFrame = stepMenuAction.instructionMenuController.parent !== stepMenuAction.instructionMenuController.getParent(hasStepMenuFrame);
                }
            }
        }

        if (hasPreserveAction && !hasStepMenuFrame) {
            eventLoop.runningActions.forEach(action => {
                if (this.preserveActionList.includes(action.type)) {
                    action.previousClassName = action.className;
                    action.className = action.type;
                }
            });
        }

        await this.prune.execute(eventLoop);

        console.log('load timeline', timelineNames);
        eventLoop.addTimelines(timelineIds);
    }
}

